'use strict';

console.info('CardioCast CMS v2.0.0');

/**
 * Packages
 */
const React = require('react');
const FuzzyReaction = require('./bootstrap').FuzzyReaction;

/**
 * Pull in application routes
 */
const Routes = require('./routes');

FuzzyReaction.startApp(Routes);

/**
 * Pull in css/scss/js file assets
 */
require('./assets');
